<div class="container-fluid py-3">
  <!-- Main Offer Banner -->
  <div class="row justify-content-center mb-3">
    <div class="col-12 col-md-10 col-lg-8 text-center">
      <img src="assets/images/main-offer.jpeg" alt="Main Offer"
           class="rounded-3 shadow-sm main-offer-banner">
    </div>
  </div>

  <!-- Scratch & Win Title -->
  <div class="row justify-content-center mb-3">
    <div class="col-12 text-center">
      <h2 class="fw-bold text-primary mb-1">Scratch & Win!</h2>
      <h6 class="fw-normal text-muted mb-0">Uncover amazing offers by scratching the cards below.</h6>
    </div>
  </div>

  <!-- Scratch Cards Grid -->
  <div class="row g-3 justify-content-center">
    <div *ngIf="allGifts.length == 0" class="row m-0 mt-2">
      <div class="col-md-12 text-center">
        <div class=" p-3">
          <h2 class="bouncing-text text-danger">Purchase now, to avail exciting offers !!</h2>
          <img src="./assets/images/accessories.jpg" alt="" style="width:2px; height:5px">
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-4 col-lg-3" *ngFor="let gift of allGifts">
      <div class="card shadow-sm h-100 overflow-hidden">
        <div class="card-body p-0 position-relative overflow-hidden">
          <div #card
               class="scratch-card position-relative"
               [ngStyle]="{'background-image': getCardBackground(gift)}">
          </div>

          <div *ngIf="isGiftExpired(gift)" class="expired-label">
            Expired
          </div>

          <div *ngIf="gift.scratched" class="offer-details">
            {{ gift.giftName }}
          </div>
          <div class="unscratched-status text-white text-center">
            {{ gift.status }}
          </div>
        </div>
        <div *ngIf="!gift.scratched && !isGiftExpired(gift) && gift.remainingValidityDays!=0 " class="text-center validity-days"
             [ngClass]="getValidityClass(gift.remainingValidityDays)">
          <i class="bi bi-clock-history me-2"></i>
          <span class="days-count">{{ gift.remainingValidityDays }}</span>
          <span class="days-label">{{ gift.remainingValidityDays === 1 ? 'Day' : 'Days' }} Left</span>
        </div>
      </div>
    </div>
  </div>
</div>
